import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AcademyAdministratorOperation } from '../model/AcademyAdministratorOperation';
import { AcademyAdministratorType } from '../model/AcademyAdministratorType';
import { AdministratorEntity } from '../model/AdministratorEntity';
import { Club } from '../model/Club';
import { AdministrationService } from './administration.service';
import { AuthService } from './auth.service';
import { LoadingService } from './loading.service';

@Injectable({
  providedIn: 'root'
})
export class ClubService {

  orgId!:string;
  constructor(private authService:AuthService, private administrationService:AdministrationService, private loadingService:LoadingService, private router: Router) {
  }

   async getClubInfo():Promise<Club> {
    try {
      this.loadingService.showLoading();
      this.orgId = this.authService.orgId;
      let entity: AdministratorEntity = {
        operation: AcademyAdministratorOperation.FIND,
        payload: {
          id: this.orgId,
        },
        type: AcademyAdministratorType.CLUBES,
      };
      const response = await this.administrationService
        .sendRequest(entity)
        .pipe(catchError(this.handleError.bind(this)))
        .toPromise();
      this.loadingService.hideLoading(); 
      if (response.code === 200 && response.response) {
        return response.response as Club;
      } else {
        throw new Error('No se encontró información del club');
      }
    } catch (error) {
      this.loadingService.hideLoading();
      console.log('Ocurrió un error validando la solicitud: ', error);
      throw error;
    }
  }



  
  private handleError(error: HttpErrorResponse) {
    this.loadingService.hideLoading();
    if (error.status === 422) {
      this.router.navigate(['/403']);
      return throwError(
        () => new Error('No se puede procesar la consulta de la información del club')
      );
    } else {
     // Return an observable with a user-facing error message.
     this.router.navigate(['/500']);
      return throwError(
        () => new Error('Error desconocido consultando la información del club')
      );
    }

 
  }
}
